import React from 'react'
import { Field, reduxForm } from 'redux-form'
//import validate from './validate'
//import renderField from './renderField'

const WizardFormFirstPage = props => {
  const { handleSubmit } = props
  return (
    <form onSubmit={handleSubmit}>
        <div className="rev-row">
             <div className="card card--raised with-shadow">
        <p className="sd-numreview"> <text> Avan International Resort, a 3-star resort, is located in the vibrant city of Orlando. This property features a range of attractive facilities including a fitness center, a pool bar, a games room, and a year-round outdoor pool. Guests can also enjoy the convenience of private check-in and check-out services, a concierge service, and free WiFi throughout the property. For those traveling with children, family rooms and a baby safety gate are available.

The resort offers a variety of units, all equipped with tea and coffee making facilities, air-conditioning, a fridge, a work desk, and a flat-screen TV with cable channels. For added comfort, each unit features a private bathroom with free toiletries, a shower, and a bath. Some units offer additional amenities such as pool views, a city view, a sofa bed, and a microwave. 

Guests at Avanti International Resort can explore a number of nearby attractions. The Wheel at ICON Park Orlando is less than 0.6 mi away, while the Orange County Convention Center is just 1.2 mi from the property. SeaWorld Orlando and Universal Studios Orlando are within 3.1 mi. For those interested in shopping, Florida Mall is 6.2 mi away. The resort is conveniently located 11 mi from Orlando International Airport.</text></p>
        {/*  
          <Field
            name="firstName"
            type="text"
            component={renderField}
            label="First Name"
          />
          <Field
            name="lastName"
            type="text"
            component={renderField}
            label="Last Name"
          />
          */}
        </div>
      </div>
      <div>
        <button type="submit" className="btn btn-success">
          Next - Guest Details
        </button>
      </div>
    </form>
  )
}

export default reduxForm({
  form: 'wizard', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
 // ,validate
})(WizardFormFirstPage)
